import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiResource } from '../../resources/api.resource';
import { ActivosModel } from '../../models/activos-model';

import { ApiService } from 'src/app/services/api.service';

declare var $: any;
declare var google: any;

@Component({
  selector: 'activos-detalle-component',
  templateUrl: './activos-detalle.component.html',
  styleUrls: ['./activos-detalle.component.scss']
})
export class ActivosDetalleComponent implements OnInit {

  @Output() uuid = new EventEmitter();
  @Input('configuration') configuration;

  public respuestaDeObtenerActivos: ActivosModel = new ActivosModel();
  public activoSeleccionado = null;


  public isAnimating = false;
  public numeroDePaginadorSeleccionado = 1;
  public estaActivadoElBotonVerMas = false;
  public currentImage: any;
  public current: any;

  map: any;
  marker: any;

  public latitude = -28.68352;
  public longitude = -147.20785;
  public mapType = 'roadmap'; //HYBRID, satellite, roadmap, terrain
  public markers = [
  ];


  constructor(private resource: ApiResource, private sanitized: DomSanitizer,private globals: ApiService) {

  }

  ngOnInit() {
    this.obtnerActivos(1);
  }

  regresarAPaginaPersonas() {
    this.uuid.emit('portal_principal_personas');
  }


urlServiceDescargarOnbase = `${this.globals.urlServidor}/descargarDoc/`;

  descargar(nameFile: any) {
    // window.open(this.urlServiceDescargarOnbase + nameFile, '_self');//Original
    window.open(this.urlServiceDescargarOnbase + nameFile, '_blank');
  }


  obtnerActivos(page) {
    this.estaActivadoElBotonVerMas = false;
    this.numeroDePaginadorSeleccionado = page;
    this.resource.obtenerActivos(page).subscribe(resp => {
      this.respuestaDeObtenerActivos = resp;
    }, err => {
      this.respuestaDeObtenerActivos = new ActivosModel();
    });
  }

  verificarImagenXSS(imageUrl) {
    let value: any = `url(${imageUrl})`;
    value = this.sanitized.bypassSecurityTrustStyle(value);
    return value;
  }

  private prefixID(num) {
    return `itm-nm-${num}`;
  }

  private moveSlider(direction, data, index) {
    let _$ = $;
    let _names = {
      current: '_$currentSlide',
      images: '_$images',
      animation: '_$isAnimating',
      stopRight: '_$stopRight',
      stopLeft: '_$stopLeft'
    };

    let { id, images } = data;
    let imgLen = images.length;

    let stopRValue = (data[_names.stopRight] === true && direction === 1);
    let stopLValue = (data[_names.stopLeft] === true && direction === 1);

    if (this.isAnimating === true && (stopRValue === false && stopLValue === false)) {
      this.isAnimating = false;
    }

    if (this.isAnimating === true || stopRValue || stopLValue) {
      return false;
    }

    let $container = _$(`#${this.prefixID(index)} .item-gallery`);
    let $sel = $container.find('.gallery-container');
    let $controls = $container.find('.gallery-controls');
    let $items = $sel.children('.image');

    let $current;
    let changeSlide = false;
    let currentDir;

    this.isAnimating = true;

    if (!data[_names.current]) {
      data[_names.current] = 0;
    }

    if (!data[_names.images]) {
      data[_names.images] = $items;
    }

    switch (direction) {
      case 1:
        /*
         *  Move to: Right
         */

        if (data[_names.current] < (imgLen - 1)) {
          data[_names.current]++;

          changeSlide = true;
          currentDir = _names.stopRight;
          data[_names.stopLeft] = false;

          if ($controls.find('.arrow-left').hasClass('disabled')) {
            $controls.find('.arrow.arrow-left').removeClass('disabled');
          }
        }

        break;

      case -1:
        /*
         *  Move to: Left
         */

        if (data[_names.current] > 0) {
          data[_names.current]--;

          changeSlide = true;
          currentDir = _names.stopLeft;
          data[_names.stopRight] = false;

          if ($controls.find('.arrow-right').hasClass('disabled')) {
            $controls.find('.arrow.arrow-right').removeClass('disabled');
          }

          if (data[_names.current] == 0) {
            $controls.find('.arrow.arrow-left').addClass('disabled');
          }
        }

        break;
    }

    if (changeSlide) {
      $current = _$(data[_names.images][data[_names.current]]);
      $current.addClass('next');

      $container.find('.gallery-total .current').text(data[_names.current] + 1);

      if (data[_names.current] == (imgLen - 1)) {
        data[currentDir] = true;

        if (currentDir == '_$stopRight') {
          $controls.find('.arrow.arrow-right').addClass('disabled');
        } else if (currentDir == '_$stopLeft') {
          $controls.find('.arrow.arrow-left').addClass('disabled');
        }
      }

      setTimeout(() => {
        $sel.find('.image.current').removeClass('current');
        $current.removeClass('next').addClass('current');

        this.isAnimating = false;
      }, 200);
    }
  }

  moveSliderLeft(data, index) {
    this.moveSlider(-1, data, index);
  }

  moveSliderRight(data, index) {
    this.moveSlider(1, data, index);
  }

  range(num, from = 0, to = 1) {
    const items = [];

    for (let a = 0; a < num; a++) {
      items.push(a + 1);
    }

    return items;
  }


  filtrarActivos(event: any) {
    event.preventDefault();

    let $city = $('.filter-city').val() + '';
    let $type = $('.filter-type').val() + '';
    let not = ['', null, 'null'];
    let data = {
      page: 1
    };

    if (not.indexOf($city) < 0) {
      data['city'] = $city;
    }

    if (not.indexOf($type) < 0) {
      data['type'] = $type;
    }



    this.resource.filtrarActivos(data).subscribe(resp => {
      this.respuestaDeObtenerActivos = resp;
    }, err => {
      this.respuestaDeObtenerActivos = new ActivosModel();
    });



  }

  showImage(image) {
    const _$ = $;

    const $parent = '#galleryList';
    const $showCurrent = _$('.gallery-view .view-current');
    const $items = _$($parent + ' .item');
    const $element = _$($parent + ' .item.itm-' + image.id);

    $items.removeClass('current');
    $element.addClass('current');

    // this.currentImage = this.sanitized.bypassSecurityTrustStyle(`url(${image.url})`);
    this.currentImage = image.url;
  }

  checkCurrent(current) {
    return this.current === current ? ' current' : '';
  }

  detallarActivo(data) {

    this.estaActivadoElBotonVerMas = true;
    this.activoSeleccionado = data;
    this.currentImage = data.images[0].url;


    // debugger;

    this.latitude=data.latitude - 0;
    this.longitude=data.longitude - 0;

    this.addMarker(this.latitude, this.longitude);

    this.estaActivadoElBotonVerMas = true;





  }




  addMarker(lat: number, lng: number) {
    this.markers=[];
    this.markers.push({ lat, lng, alpha: 1 });
  }
 



}
